import { useMemo } from 'react';
import {
  useDealershipAddress,
  useDealershipConfiguration
} from '~/context/dealership/StaticContext';
import { HygraphDealershipAddress } from '~/contracts/common/HygraphDealership';

export default function useGoogleMapsDirection(
  addressOverride?: Partial<HygraphDealershipAddress>
): string {
  const defaultAddress = useDealershipAddress();
  const address = addressOverride ?? defaultAddress;
  const { name } = useDealershipConfiguration();

  return useMemo(() => {
    const url = new URL('https://www.google.com/maps/dir/?api=1');
    url.searchParams.set(
      'destination',
      `${name}, ${address.street1}, ${address.city}, ${address.state} ${address.zip}`
    );

    return url.toString();
  }, [address.city, address.state, address.street1, address.zip, name]);
}
